import type React from "react";
import { Box, Text } from "@simplybusiness/mobius";
import type { AdditionalDisclosures, QuoteVertical } from "../../../../types";
import { camelToTitleCase } from "../../../../../../utils/text";

type Props = {
  vertical?: QuoteVertical;
  additionalDisclosures: AdditionalDisclosures;
};

const renderedLayout = (items: (string | React.JSX.Element)[]) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Box
      className="mobius-additional-coverage-info --has-divider"
      data-testid="additional-coverage-info"
    >
      <Text className="mobius-additional-coverage-info__title" elementType="h3">
        Additional Coverage Information
      </Text>
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            <p className="mobius-additional-coverage-info__text">{item}</p>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export const AdditionalCoverageInformation = ({
  vertical,
  additionalDisclosures,
}: Props) => {
  const additionalDisclosuresInformation = () => {
    if (vertical === "workers_compensation") {
      return Object.entries(additionalDisclosures! || {}).map(
        ([key, value]) => (
          <>
            <strong>{camelToTitleCase(key)}</strong>: {value}
          </>
        ),
      );
    }

    return Object.values(additionalDisclosures!)[0] as unknown as string[];
  };

  return renderedLayout(additionalDisclosuresInformation());
};
